import { DEVICE_TYPE } from '../constants';
export var getDeviceType = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? DEVICE_TYPE.MOBILE
        : DEVICE_TYPE.DESKTOP;
};
